import React from "react";
import { useSelector } from "react-redux";
import { Outlet, Navigate } from "react-router-dom";
import Layout from "../pages/Layout";

const ProtectedRoutes = () => {
  const isAuthenticated = useSelector((state) =>
    state.auth.authData?.[0]?.isAuthenticated ?? false
  );
  const plantDataFromRedux = useSelector((state) => state.plant?.isAuthenticatedPlant);
  const isRememberMe  = localStorage.getItem("rememberMeClicked")

  return (isAuthenticated || isRememberMe) && plantDataFromRedux ? (
    <Layout>
      <Outlet />
    </Layout>
  ) : (
    <Navigate to="/login" />
  );
};

export default ProtectedRoutes; 
